(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpConfirmController', GtpConfirmController);

    GtpConfirmController.$inject = ['$scope', '$uibModalInstance', 'GtpService', 'gtpItem', 'dataAction'];

    function GtpConfirmController($scope, $uibModalInstance, GtpService, gtpItem, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;
            vm.gtpData = gtpItem[0];
            vm.itemOne = true;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                GtpService[dataAction.methodService](vm.gtpData).then(success).catch(error);
            }

        }

        function success() {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;

            GtpService.successModalConstructor(vm.action, isMultiple);
            if (dataAction.methodExtra) {
                dataAction.methodExtra(gtpItem);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, vm.action);
        }

    }
})();

